import { render, staticRenderFns } from "./CompetitionFilterMyCompetitionFilter.vue?vue&type=template&id=521c1fec&scoped=true"
import script from "./CompetitionFilterMyCompetitionFilter.vue?vue&type=script&lang=js"
export * from "./CompetitionFilterMyCompetitionFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c1fec",
  null
  
)

export default component.exports